import React from "react";

// Ícono "Group 13" del Figma — cuadrado verde oliva con flecha, usado en las
// cards de acceso rápido/plantilla en varias pantallas del módulo Checklist.
// bgColor/arrowColor son configurables por si hace falta cambiarlos más
// adelante (por uso puntual, o el default acá abajo para todos los usos).
export function ChlCardIcon({ size = 15, bgColor = "#7B9355", arrowColor = "#C4D693" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="15" height="15" rx="2" transform="matrix(-1 0 0 1 15 0)" fill={bgColor} />
      <rect width="13.3333" height="13.3333" transform="matrix(-1 0 0 1 14.1667 0.833496)" fill={bgColor} />
      <path d="M4.72228 10.2777L10.2778 4.72217M4.72228 4.72217H10.2778V10.2777" stroke={arrowColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

// Ícono "-.svg" del Figma — guioncito relleno, se usa en las KPI cards
// numéricas (no porcentuales) cuando el valor es 0/sin datos, en vez de
// mostrar el número "0".
export function ChlDashIcon({ width = 13, height = 6, color = "#001936" }) {
  return (
    <svg width={width} height={height} viewBox="0 0 13 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 5.6V0H12.65V5.6H0Z" fill={color} />
    </svg>
  );
}
